import { useTranslation } from 'react-i18next';
import myJourneyStyle from './MyJourney.module.scss';
import { myJourney } from '../../../data/MyJourney';
import Company from './company/Company';
import SectionHeading from '../../elements/sectionHeading/SectionHeading';

const MyJourney = () => {
    const { t } = useTranslation();

    return (
        <section className={myJourneyStyle.section}>
            <div className={myJourneyStyle.inner}>
                <SectionHeading
                    eyebrow={t('myJourney.eyebrow')}
                    title={t('myJourney.myJourney')}
                    description={t('myJourney.description')}
                />

                <ol className={myJourneyStyle.timeline}>
                    {myJourney?.map((company, i) => (
                        <Company key={`${company.companyName}-${i}`} company={company} delay={i * 80} />
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default MyJourney;
